<template>
  <div id="app" :style="appThemeStyle" v-if="!loading">
    <!-- <Header v-if="isShow" /> -->
    <router-view />
    <!-- <Footer v-if="isShow" /> -->
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";
import { mapActions } from 'vuex'

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      loading: true,
      appThemeStyle: {},
      isShow: false
    };
  },
  watch: {
    "$route"(newVal) {
      if (['Privacy', 'Privacy2', 'Terms', 'Conduct'].indexOf(newVal.name) != -1) {
        this.isShow = false;
        this.appThemeStyle = Object.assign({}, {})
      } else {
        this.isShow = true;
        this.configTheme(this.$store.state.data);
      }
    }
  },
  created() {
    this.getData().then(res => {
      if (res) {
        this.loading = false
        this.$store.commit('updateData', res)
        if (['Privacy', 'Privacy2', 'Terms', 'Conduct'].indexOf(this.$route.name) == -1) {
          this.configTheme(this.$store.state.data)
        }
      }
    });
    this.isShow = this.$route.name && ['Privacy', 'Privacy2', 'Terms', 'Conduct'].indexOf(this.$route.name) == -1;
    document.querySelector('.preloader').style.display = 'none'
  },
  methods: {
    ...mapActions([
      'getData'
    ]),
    configTheme(data) {
      this.appThemeStyle = {
        // background: `no-repeat`,
        backgroundColor: `${data.theme.bg_color}`,
        // backgroundImage: `url( '~@/assets/images/bg.png' )`,
        // backgroundImage: `url( ${data.theme.bg_img} )`,
        // backgroundSize: "cover"
      };
    }
  }
};
</script>
<style>
body{
  margin:0;
}
#app {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  /* background-size: 100% 100%; */
  overflow-x: hidden;
}
</style>
<style lang="less">
body.iswebmob{
  .header-seciton{
    header{
      .nav{
        a:first-child{
          display: none;
        }
      }
      .btn{
        display: none;
      }
    }
    .page1{
      .meta{
        margin-right: 0;
        padding: 0 12px;
        h1{
          font-size: 23px;
          line-height: 32px;
          margin-bottom: 10px
        }
      }
      .appimgs{
        display: none;
      }
    }
  }
  .page2{
    padding: 80px 0 20px;
    .row{
      margin-top: 60px;
      flex-direction: column;
      .col{
        flex: 1;
        max-width: inherit;
        margin-bottom: 40px;
      }
    }
  }
  .footer{
    line-height: inherit;
    .wrap{
      flex-direction: column;
      height: 100%;
      justify-content: space-evenly;
    }
  }
  .main.about{
    .page1, .page2{
      h1{
        font-size: 26px;
      }
      .desc{
        padding: 0 12px;
      }
      .btn{
        margin-top: 36px !important;
      }
    }
    .page2{
      padding: 40px 0;
    }
  }
}
</style>
